/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { registerFormatType, toggleFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton } from '@wordpress/block-editor';
import React from 'react';

/**
 * Block constants
 */
const name = 'advanced/highlight';

export const highlight = {
    name,
    title: 'Couleur jaune mobile',
    tagName: 'span',
    className: 'smartfire-yellow-mobile',
    attributes: {
        style: 'style',
    },
    edit({ isActive, value, onChange }) {
        const onToggle = () => {
            onChange(
                toggleFormat(value, {
                    type: name,
                }),
            );
        };
        return (
            <Fragment>
                <RichTextToolbarButton
                    icon="editor-highlight"
                    title={'Couleur jaune mobile'}
                    onClick={onToggle}
                    isActive={isActive}
                />
            </Fragment>
        );
    },
};

export default function registerHighlight() {
    [highlight].forEach(({ name, ...settings }) => registerFormatType(name, settings));
}
